import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { OptionsProvider, Select } from '@shared/ui/components/Select';
import { cn } from '@shared/utils/helpers';

export type SelectInputProps = PropsWithClassName<{
  options: OptionsProvider;
  required?: boolean;
  placeholder?: string;
  error?: string;
  value?: string | null;
  onChange?: (value: string | number | null) => void;
}>;

export function SelectInput({ options, required, placeholder, error, value, onChange, className }: SelectInputProps) {
  return (
    <Select<string | number>
      options={options}
      className={cn({ 'border-red-500': error }, className)}
      required={required}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
}
